class ProductTabs extends HTMLElement {
  constructor() {
    super();

    let activeTab = this.querySelector('.product-tabs__tabs .is-active'),
      contentContainer = this.querySelector('.product-tabs__content'),
      tabsContainer = this.querySelector('.product-tabs__tabs'),
      width = window.innerWidth;

    const mediaQuery = window.matchMedia(
      "(max-width:" + window.mediaStrings.mobileSmall + ")"
    );

    this.listeners(activeTab, contentContainer, tabsContainer, mediaQuery, width);

    this.resetTabs(activeTab, contentContainer, tabsContainer, mediaQuery);
    this.hideMobile(contentContainer, mediaQuery);
    this.createProductDescriptionExcerpt();
  }

  listeners(activeTab, contentContainer, tabsContainer, mediaQuery, width) {

    this.querySelectorAll('.product-tabs__tabs .js-tab').forEach((tab) => tab.addEventListener('click', (event) => {
      this.openTabs(event, contentContainer, tabsContainer, mediaQuery);
    }));

    window.addEventListener("resize", (event) => {
      if (window.innerWidth != width) {
        debounce(this.resetTabs(activeTab, contentContainer, tabsContainer, mediaQuery), 200)
        debounce(this.hideMobile(contentContainer, mediaQuery))
      }
    });

  }

  hideMobile(contentContainer, mediaQuery) {
    let activeContentIndex = this.querySelector('.product-tabs__content .js-tab-content:not(.hidden)');
    let activeTab = this.querySelector('.product-tabs__tabs .is-active');

    if (mediaQuery.matches) {
      if (activeTab && activeContentIndex) {
        activeTab.classList.remove('is-active');
        contentContainer.querySelector(`.js-tab-content[data-index="${activeContentIndex.dataset.index}"`).classList.add('hidden');
      }
    } else {
      let firstTabDesktop = this.querySelector('.js-tab');
      if (!firstTabDesktop) return;
      if (!firstTabDesktop.classList.contains('is-active')) {
        firstTabDesktop.click();
      }
    }
  }

  openTabs(event, contentContainer, tabsContainer, mediaQuery) {

    let tabIndex = event.target.dataset.index;

    let tabContent = contentContainer.querySelectorAll('.js-tab-content');
    let allTabs = tabsContainer.querySelectorAll('.product-tabs__tabs .js-tab');

    // Set active Tab
    event.target.classList.toggle('is-active');
    allTabs.forEach((tab => {
      let iconCaret = tab.querySelector('.icon-caret');

      if (tab != event.target) {

        tab.classList.remove('is-active');
        iconCaret.classList.remove('is-active');
      }
    }))

    // Set active content
    tabContent.forEach((content => {
      if (content.dataset.index == tabIndex) {
        this.resetTabs(event.target, contentContainer, tabsContainer, mediaQuery);
        content.classList.toggle('hidden');
        if (window.matchMedia('(max-width: 768px)').matches) {
          content.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      } else {
        content.classList.add('hidden');
      }
    }))
  }

  // Reset tabs based on screen size
  resetTabs(target, contentContainer, tabsContainer, mediaQuery) {
    if (mediaQuery.matches) {
      target.after(contentContainer);
    } else {
      tabsContainer.after(contentContainer);
    }
  }

  createProductDescriptionExcerpt() {
    let content = this.querySelector('.product__description');

    if (content == null || content == undefined) return;

    if (content.textContent.length > 300) {
      const excerpt = document.createElement('div');
      const expanded = document.createElement('div');
      const read_more = document.createElement('a');
      const read_less = document.createElement('a');

      read_more.classList.add('product__read-more');
      read_less.classList.add('product__read-more', 'product__read-more--less');
      excerpt.classList.add('product__excerpt--truncated');
      expanded.classList.add('product__excerpt--full');

      excerpt.innerHTML = content.innerHTML.substring(0, 400);
      expanded.innerHTML = content.innerHTML;
      read_more.innerHTML = `Read More <span class="icon"></span>`;
      read_less.innerHTML = `Read Less <span class="icon"></span>`;

      read_more.href = "#";
      read_less.href = "#";

      excerpt.appendChild(read_more);
      expanded.appendChild(read_less);

      content.replaceChildren(excerpt);
      content.appendChild(expanded);

      read_more.addEventListener('click', event => {
        event.preventDefault();

        content.classList.add('product__description--expand');
      });

      read_less.addEventListener('click', event => {
        event.preventDefault();

        content.classList.remove('product__description--expand');
      });
    }

  }
}

customElements.define('product-tabs', ProductTabs);

